export const votePrefsSlicer = (state) => {
  if (!state) return state;
  const newState = {};
  for(let votePrefKey in state) {
    let votePref = state[votePrefKey];
    let newVotePref = {}
    for(let key in votePref) {
      if (key === "message") continue;
      newVotePref[key] = votePref[key];
    }
    newState[votePrefKey] = newVotePref;
  }
  return newState;
};




// WEBPACK FOOTER //
// ./src/state/votePrefs/slicer.js